import {MaterialCommonModule} from 'src/app/material-modules/material-common.module';
import {ConjuntoCategoriaContabilRoutingModule} from './conjunto-categoria-contabil-routing.module';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ConjuntoCategoriaContabilComponent} from './conjunto-categoria-contabil.component';
import {
    CadastrarConjuntoCategoriaContabilComponent
} from './cadastrar-conjunto-categoria-contabil/cadastrar-conjunto-categoria-contabil.component';
import {ComboPesquisavelModule} from '../common/combo-pesquisavel/combo-pesquisavel.module';
import {ComboGenericoModule} from '../shared/combo-generico/combo-generico.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

@NgModule({
    declarations: [
        ConjuntoCategoriaContabilComponent,
        CadastrarConjuntoCategoriaContabilComponent
    ],
    imports: [
        CommonModule,
        ConjuntoCategoriaContabilRoutingModule,
        MaterialCommonModule,
        ComboPesquisavelModule,
        ComboGenericoModule,
        FormsModule,
        ReactiveFormsModule,
    ]
})
export class ConjuntoCategoriaContabilModule {
}
